import { useEffect } from "react";

// Adds `.in-view` to any element matching `.reveal` (and any inner
// `[data-reveal]` children) once it enters the viewport. One observer
// per page; cleans up on unmount. Pages call this hook in their
// top-level component to opt in.
export default function useReveal(deps = []) {
  useEffect(() => {
    if (typeof IntersectionObserver === "undefined") return;
    const targets = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in-view");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    targets.forEach((t) => io.observe(t));
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
